<div class="flex align-items-end gap-2 p-2 border-1 border-round-2xl surface-0" [ngClass]="borderClass">
    <textarea #input pTextarea [(ngModel)]="draft" rows="1" [autoResize]="true"
        class="assistant-textarea flex-1 text-base border-none shadow-none bg-transparent outline-none"
        [placeholder]="placeholder"
        [disabled]="disabled" (keydown.enter)="onKeydownEnter($event)"></textarea>
    <p-button icon="pi pi-arrow-up" [rounded]="true" [severity]="severity"
        [disabled]="disabled || !draft.trim()" (onClick)="onSubmit()"></p-button>
</div>
